<template>
  <div class="my-referral-info">
    <div class="card-container my-reward">
      <div class="card-content reward-container">
        <div v-if="!isPc && companyId && !wxUserHasBindRewards" class="get-rewards">
          <el-button class="get-rewards-btn" @click="handleGetQrCode">{{ $t(`${i18nKeyPrefix}.label.getRewards`) }}</el-button>
        </div>
        <div class="reward-line">
          <div class="reward-value cash">
            <span class="value">{{ cashConsumed|formatBigNumber(1) }}</span>
            <span class="units">{{ $t(`${i18nKeyPrefix}.rewardsUnit.cash`) }}</span>
          </div>
          <el-button v-if="showRedeem" round class="reward-btn is-active" @click="onMyReferralBtnClick">{{ $t(`${i18nKeyPrefix}.btn.myReferrals`) }}</el-button>
          <el-button v-else round class="reward-btn is-active" @click="onMyRedeemBtnClick">{{ $t(`${i18nKeyPrefix}.btn.redeemHistory`) }}</el-button>
        </div>
        <div class="reward-line">
          <div class="reward-value points">
            <span class="value">{{ pointsConsumed|formatBigNumber(1) }}</span>
            <span class="units">{{ $t(`${i18nKeyPrefix}.rewardsUnit.jdEPoints`) }}</span>
          </div>
          <el-button round class="reward-btn" :class="rewardsInfo.isRedeemPointsEnabled ? 'is-active' : 'is-disable'" @click="onRedeemBtnClick">
            {{ $t(`${i18nKeyPrefix}.btn.redeemPoints`, {points: waitRedeemPoints || ''}) }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="card-container reward-detail">
      <div class="card-title">
        <div class="title">
          <span>{{ rewardDetailTile }}</span>
          <div v-if="isPc && companyId && !wxUserHasBindRewards" class="get-rewards">
            <el-button class="get-rewards-btn" @click="handleGetQrCode">{{ $t(`${i18nKeyPrefix}.label.getRewards`) }}</el-button>
          </div>
        </div>
        <div v-if="showRedeem" class="title-tip" @click="onRedeemTipIconClick">
          <i class="el-icon-question tip-icon"></i>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="card-content">
        <div v-show="timelineInfoList.length > 0" v-infinite-scroll="infiniteLoad" class="timeline-list" :infinite-scroll-disabled="disableInfinite">
          <div v-for="(info, index) in timelineInfoList" class="timeline-item" :key="index">
            <div class="timeline-item-timestamp">
              <span class="timestamp-year">{{ info.timestamp.year }}</span>
              <span class="timestamp-date">{{ info.timestamp.date }}</span>
            </div>
            <div class="timeline-item-node">
              <div class="node-tail"></div>
              <div class="node-icon"></div>
            </div>
            <div class="timeline-item-content" :class="showReferral ? 'referral-info' : 'redeem-info'">
              <template v-if="showReferral">
                <div class="applicant-name">
                  <span>{{ info.applicantName }}</span>
                </div>
                <div class="job-name">
                  <span>{{ info.jobName }}</span>
                </div>
                <div class="reward-type">
                  <span class="reward-step-name">{{ $t(info.stepNameI18nKey) }}</span>
                  <div class="reward-value">
                    <span class="reward-icon">
                      <i :class="info.reward.icon"></i>
                      </span>
                    <span>{{ info.reward.type !== REWARDS_TYPE.points ? '￥' : '' }}{{ info.reward.value|formatBigNumber(1) }}</span>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="redeem-info-warpper">
                  <div class="redeem-cost">
                    <span>{{ info.cost|formatBigNumber(1) }}</span>
                  </div>
                  <div class="redeem-goods">
                    <span>{{ $t(info.goods.nameI18nkey) }}</span>
                  </div>
                </div>
                <div class="redeem-detail-btn-container">
                  <el-button v-if="info.detailBtn.show" class="redeem-detail-btn" round @click="onRedeemDetailBtnClick(info)">{{ $t(info.detailBtn.labelI18nKey) }}</el-button>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div v-if="timelineInfoList.length < 1" class="empty-content">
          <span>{{ $t(`${i18nKeyPrefix}.message.${showReferral ? 'noReferrals' : 'noRedeemHistory'}`) }}</span>
        </div>
      </div>
    </div>
    <van-dialog v-model="redeemDialog.show" confirm-button-color="var(--custom-color)" :show-confirm-button="!redeemDialog.loading">
      <div class="redeem-dialog-content">
        <div v-show="redeemDialog.loading" class="loading-container">
          <RectLoading rect-background="var(--custom-color)"/>
          <div class="loading-tip">{{ redeemDialog.tipMessage }}</div>
        </div>
        <div v-if="!redeemDialog.loading" class="redeem-result">
          <div class="redeem-code-tip-message">
            <div v-if="redeemDialog.result.hasError" class="error-message">{{ $t(`${i18nKeyPrefix}.message.redeemHasError`) }}</div>
            <div v-else class="success-message">{{ $t(`${i18nKeyPrefix}.message.redeemSuccess`) }}</div>
            <div class="copy-message">{{ $t(`${i18nKeyPrefix}.message.copyRedeemCodeOrClose`) }}</div>
          </div>
          <div class="redeem-code-list">
            <div v-for="(redeemCode, index) in redeemDialog.result.redeemCodes" class="redeem-code-container" :key="index">
              <span>{{ redeemCode }}</span>
              <el-button
                v-clipboard:copy="redeemCode"
                v-clipboard:success="onCopyRedeemCodeSuccess"
                v-clipboard:error="onCopyRedeemCodeError"
                class="redeem-code-copy-btn"
                round
              >
                {{ $t('common.btn.copy') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="redeemDetailDialog.show" confirm-button-color="var(--custom-color)">
      <div class="redeem-info-detail-dialog-content">
        <div class="tip-message">
          <span>{{ $t(`${i18nKeyPrefix}.message.copyRedeemCode`) }}</span>
        </div>
        <div class="redeem-code-container">
          <span>{{ redeemDetailDialog.redeemCode }}</span>
          <el-button
            v-clipboard:copy="redeemDetailDialog.redeemCode"
            v-clipboard:success="onCopyRedeemCodeSuccess"
            v-clipboard:error="onCopyRedeemCodeError"
            class="redeem-code-copy-btn"
            round
          >
            {{ $t('common.btn.copy') }}
          </el-button>
        </div>
      </div>
    </van-dialog>
    <WeChatBindQrCodeDialog
      :show.sync="showWeChatBindQrCodeDialog"
      :companyId="companyId"
      :isPc="isPc"
    ></WeChatBindQrCodeDialog>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { formatBigNumber } from '@/components/filters'
import { mapActions, mapGetters } from 'vuex'
import RectLoading from '@/components/loading/rectLoading'
import { deviceType } from '@/utils/common'
import WeChatBindQrCodeDialog from '../../../../components/mobile/referral/wechatBindQrCodeDialog.vue'

function createTimelineTimestamp (timestamp, vm) {
  return {
    value: timestamp && moment(timestamp),
    get locale () {
      return vm.$i18n.locale === 'en' ? 'en' : 'zh-cn'
    },
    get year () {
      return this.value?.locale(this.locale).format('YYYY') || ''
    },
    get date () {
      return this.value?.locale(this.locale).format('MMM Do') || ''
    }
  }
}

const REDEEM_GOODS = {
  jdEcard: 'JD_E_CARD'
}

const REWARDS_TYPE = {
  points: 'points',
  cash: 'cash',
  payroll: 'payroll'
}

const REWARD_ICON_CLASS = {
  points: 'iconfont iconpoint',
  cash: 'iconfont iconcash1',
  payroll: 'iconfont iconpayroll'
}

export default {
  components: {
    RectLoading,
    WeChatBindQrCodeDialog
  },
  data () {
    return {
      REWARDS_TYPE,
      REDEEM_GOODS,
      i18nKeyPrefix: 'personal.referrals.rewards',
      showRedeem: false,
      rewardsInfo: {
        isRedeemPointsEnabled: false,
        balance: {
          cash: 0,
          payroll: 0,
          points: 0
        },
        consumed: {
          cash: 0,
          payroll: 0,
          points: 0
        }
      },
      pageInfo: {
        total: 2,
        pageSize: 20,
        page: 1
      },
      disableInfinite: false,
      redeemHistory: [],
      referralHistory: [],
      timelineInfoList: [],
      redeemDialog: {
        show: false,
        loading: false,
        tipMessage: null,
        result: {
          redeemCodes: [],
          hasError: false
        }
      },
      redeemDetailDialog: {
        show: false,
        redeemCode: null
      },
      showWeChatBindQrCodeDialog: false
    }
  },
  computed: {
    ...mapGetters('account', ['wxUserHasBindRewards']),
    isEn () {
      return this.$i18n.locale === 'en'
    },
    isPc () {
      return deviceType.isPc
    },
    cashConsumed () {
      return (this.rewardsInfo.consumed.cash + this.rewardsInfo.consumed.payroll) / 100 || 0
    },
    pointsConsumed () {
      return (this.rewardsInfo.consumed.points) / 100 || 0
    },
    waitRedeemPoints () {
      const balance = (this.rewardsInfo.balance.points) / 100 || 0
      return formatBigNumber(balance, 1)
    },
    showReferral: {
      get () {
        return !this.showRedeem
      },
      set (val) {
        this.showRedeem = !val
      }
    },
    rewardDetailTile () {
      const i18nKey = this.showRedeem ? 'label.redeemHistory' : 'label.myReferrals'
      return this.$t(`${this.i18nKeyPrefix}.${i18nKey}`)
    },
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('personal', ['getMyRewards', 'getMyReferralHistory', 'getMyRedeemHistory', 'getRedeemPointsResult', 'redeemPoints']),
    handleGetQrCode () {
      if (!this.companyId) {
        return
      }
      this.showWeChatBindQrCodeDialog = true
    },
    async initData () {
      this.$eventBus.$emit('showLoading', true)
      try {
        await this.refreshMyRewardsInfo()
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async infiniteLoad () {
      this.$eventBus.$emit('showLoading', true)
      this.disableInfinite = true
      try {
        const params = {
          page: this.pageInfo.page,
          page_size: this.pageInfo.pageSize
        }
        if (!this.isPc) {
          params.company_id = this.$route.query.company_id
        }
        const actionFunc = this.showRedeem ? this.getMyRedeemHistory : this.getMyReferralHistory
        const resp = await actionFunc(params)
        if (resp) {
          this.pageInfo.total = resp.total_pages
          this.pageInfo.page += 1
          if (this.pageInfo.total > 0 && this.pageInfo.page <= this.pageInfo.total) {
            this.disableInfinite = false
          }
          const respData = resp.results
          if (this.showRedeem) {
            this.refreshRedeemHistory(respData)
          } else {
            this.refreshReferralHistory(respData)
          }
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    onMyReferralBtnClick () {
      if (this.showReferral) {
        return
      }
      this.referralHistory = []
      this.timelineInfoList = []
      this.pageInfo.page = 1
      this.pageInfo.total = 1
      this.showReferral = true
      this.infiniteLoad()
    },
    onMyRedeemBtnClick () {
      if (this.showRedeem) {
        return
      }
      this.redeemHistory = []
      this.timelineInfoList = []
      this.pageInfo.page = 1
      this.pageInfo.total = 1
      this.showRedeem = true
      this.infiniteLoad()
    },
    onRedeemBtnClick () {
      if (!this.rewardsInfo.isRedeemPointsEnabled) {
        return
      }
      this.redeemDialog.show = true
      this.redeemDialog.loading = true
      const params = { points: this.rewardsInfo.balance.points }
      if (!this.isPc) {
        params.company_id = this.$route.query.company_id
      }
      this.redeemPoints(params).then(this.loadRedeemPointsResult).then(() => {
        this.rewardsInfo.isRedeemPointsEnabled = false
      })
    },
    async refreshMyRewardsInfo () {
      const params = {}
      if (!this.isPc) {
        params.company_id = this.$route.query.company_id
      }
      const resp = await this.getMyRewards(params)
      if (resp) {
        const rewardsInfo = {
          isRedeemPointsEnabled: resp.is_redeem_points_enabled,
          balance: {
            cash: resp.balance.CASH || 0,
            payroll: resp.balance.PAYROLL || 0,
            points: resp.balance.POINTS || 0
          },
          consumed: {
            cash: resp.consumed.CASH || 0,
            payroll: resp.consumed.PAYROLL || 0,
            points: resp.consumed.POINTS || 0
          }
        }
        this.rewardsInfo = rewardsInfo
      }
    },
    refreshReferralHistory (referralData) {
      if (referralData) {
        this.referralHistory.push(...referralData)
      } else {
        referralData = this.referralHistory
      }
      if (!this.showReferral) {
        return
      }
      const vm = this
      _.forEach(referralData, (item, index) => {
        this.timelineInfoList.push({
          timestamp: createTimelineTimestamp(item.final_grant_date, this),
          applicantName: item.applicant?.name || '',
          stepNameI18nKey: `${this.i18nKeyPrefix}.referralStep.${item.step}`,
          get jobName () {
            return vm.isEn ? item.job.name : item.job.cn_name
          },
          reward: {
            type: item.reward_type,
            get icon () {
              return REWARD_ICON_CLASS[this.type]
            },
            value: item.rewards
          }
        })
      })
    },
    refreshRedeemHistory (redeemData) {
      if (redeemData) {
        this.redeemHistory.push(...redeemData)
      } else {
        redeemData = this.redeemHistory
      }
      if (!this.showRedeem) {
        return
      }
      _.forEach(redeemData, (item, index) => {
        this.timelineInfoList.push({
          data: item,
          timestamp: createTimelineTimestamp(item.created_time, this),
          goods: {
            type: item.goods_type,
            nameI18nkey: `${this.i18nKeyPrefix}.goods.${item.goods_type}`
          },
          cost: item.used_points / 100,
          detailBtn: {
            show: true,
            labelI18nKey: `${this.i18nKeyPrefix}.btn.viewJDECode`
          }
        })
      })
    },
    async loadRedeemPointsResult (resp) {
      if (resp && resp.is_finished) {
        const result = {}
        _.forEach(resp.result, (value, key) => {
          key = key.replace(/_(\w)/g, (all, letter) => letter.toUpperCase())
          result[key] = value
        })
        this.redeemDialog.result = result
        this.refreshRedeemHistory(result.redeemList)
        await this.refreshMyRewardsInfo()
        this.redeemDialog.loading = false
      } else {
        let tipMessage = this.redeemDialog.tipMessage
        if (tipMessage) {
          const originLen = tipMessage.length
          tipMessage = tipMessage.replace(/\./g, '')
          let count = originLen - tipMessage.length + 1
          if (count > 6) {
            count = 1
          }
          tipMessage += _.repeat('.', count)
        } else {
          tipMessage = this.$t(`${this.i18nKeyPrefix}.message.redeemInProcess`) + '.'
        }
        this.redeemDialog.tipMessage = tipMessage
        setTimeout(() => {
          this.getRedeemPointsResult({ task_id: resp.task_id }).then(this.loadRedeemPointsResult)
        }, 700)
      }
    },
    onCopyRedeemCodeSuccess () {
      this.onCopyRedeemCode(true)
    },
    onCopyRedeemCodeError () {
      this.onCopyRedeemCode(false)
    },
    onCopyRedeemCode (isSuccess) {
      const messageI18nKey = isSuccess ? 'copySuccess' : 'copyFail'
      const message = this.$t(`${this.i18nKeyPrefix}.message.${messageI18nKey}`)
      this.$toast({ message, position: 'bottom' })
    },
    onRedeemDetailBtnClick (redeemInfo) {
      if (redeemInfo.goods.type !== REDEEM_GOODS.jdEcard) {
        return
      }
      const redeemCode = redeemInfo.data.goods_redeem_code
      if (this.isPc) {
        const promptMsg = this.$t(`${this.i18nKeyPrefix}.message.copyWithCtrlC`)
        prompt(promptMsg, redeemCode)
      } else {
        this.redeemDetailDialog.redeemCode = redeemCode
        this.redeemDetailDialog.show = true
      }
    },
    onRedeemTipIconClick () {
      location.href = 'https://file231de032ad35.aiwall.com/v3/idea/bKxoAM6q'
    }
  }
}
</script>

<style lang="scss" scoped>
.my-referral-info {
  .card-container {
    margin-bottom: 15px;
    padding: 10px;
    border-radius: 5px;
    background: #fff;

    .card-title {
      margin: 10px 0;
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      position: relative;

      .title {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .get-rewards {
        margin-left: 14px;
        .get-rewards-btn {
          height: 30px;
          padding: 0 28px;
          border-radius: 999px;
          border-color: var(--custom-color);
          color: #fff;
          background-color: var(--custom-color);
        }
      }

      .title-tip {
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        cursor: pointer;

        .tip-icon {
          color: #158fd2;
          font-size: 26px;
        }
      }
    }

    .el-divider {
      margin: 14px 0;
    }

    .card-content {
      margin-bottom: 20px;
      padding: 0 10px;

      .empty-content {
        padding: 10px;
        font-size: 14px;
        text-align: center;
      }
    }
  }

  .my-reward {
    .reward-container {
      padding: 15px 10px 0;

      .get-rewards {
        margin-bottom: 15px;
        .get-rewards-btn {
          height: 24px;
          padding: 0 26px;
          border-radius: 999px;
          border-color: var(--custom-color);
          color: #fff;
          background-color: var(--custom-color);
        }
      }

      .reward-line {
        display: flex;
        justify-content: space-between;
        padding-left: 10px;

        ~ .reward-line {
          margin-top: 15px;
        }

        .reward-value {
          color: #676767;

          .value {
            font-size: 24px;
            line-height: 1;
          }

          .units {
            margin-left: 3px;
          }
        }

        .reward-btn {
          width: 110px;
          padding: 0;
          border-color: var(--custom-color);
          background: #fff;
          color: var(--custom-color);
          font-size: 12px;

          &.is-active {
            background: var(--custom-color);
            color: #fff;
          }

          &.is-disable {
            border-color: #bfbdbe;
            color: #fff;
            background: #bfbdbe;
          }
        }
      }
    }
  }

  .reward-detail {
    .timeline-list {
      flex: 1;
      color: #b3b3b3;

      .timeline-item {
        display: flex;

        .timeline-item-node {
          display: flex;
          width: 40px;
          justify-content: center;
          position: relative;

          .node-icon {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            border: 1px solid #a6a6a6;
            background: #fff;
            position: relative;
          }

          .node-tail {
            width: 1px;
            height: 100%;
            background: #a6a6a6;
            position: absolute;
            top: 0;
          }
        }

        .timeline-item-timestamp {
          width: 50px;

          .timestamp-year {
            display: block;
            text-align: right;
            font-size: 16px;
            color: #333333;
            line-height: 1;
          }

          .timestamp-date {
            display: block;
            white-space: nowrap;
            text-align: right;
          }
        }

        .timeline-item-content {
          flex: 1;
          padding-bottom: 30px;
        }

        &:last-child {
          .timeline-item-content {
            padding-bottom: 0;
          }
        }
      }
    }

    .referral-info {

      .applicant-name {
        font-size: 16px;
        color: #333333;
        line-height: 1;
      }

      .reward-type {
        display: flex;

        .reward-step-name {
          flex: 1;
          margin-right: auto;
        }

        .reward-value {
          width: 90px;
          margin-left: 5px;
          line-height: 1;
          font-size: 16px;
          color: var(--custom-color);

          .reward-icon {
            display: inline-block;
            width: 25px;
            height: 100%;
            margin-right: 3px;
            justify-content: center;
            position: relative;

            i {
              font-size: 24px;
              position: absolute;
              top: -2px;
            }
          }
        }
      }
    }

    .redeem-info {
      display: flex;

      .redeem-info-warpper {
        flex: 1;

        .redeem-cost {
          font-size: 24px;
          color: #333333;
          line-height: 1;
        }
      }

      .redeem-detail-btn-container {
        width: 110px;
        margin: auto 0;

        .redeem-detail-btn {
          width: 100%;
          height: 24px;
          padding: 0;
          color: #fff;
          background: var(--custom-color);
          border-color: var(--custom-color);
          font-size: inherit;
        }
      }
    }
  }

  .redeem-dialog-content {
    padding: 20px 10px 10px;
    font-size: 16px;
    text-align: center;

    .loading-container {
      padding-bottom: 15px;

      .rect-loading {
        margin: 10px 0;
        position: initial;
      }
    }

    .redeem-result {
      .redeem-code-tip-message {
        padding: 0 15px;

        .copy-message {
          margin-top: 5px;
          font-size: 14px;
        }
      }

      .redeem-code-list {
        margin-top: 15px;

        .redeem-code-container {
          margin: 5px 0;

          .el-button {
            margin-left: 10px;
            padding: 3px 18px;
            border-color: var(--custom-color);
            color: var(--custom-color);
          }
        }
      }
    }
  }

  .redeem-info-detail-dialog-content {
    padding: 20px 10px 10px;
    font-size: 16px;
    text-align: center;

    .redeem-code-container {
      margin: 15px 0 5px;

      .el-button {
        margin-left: 10px;
        padding: 3px 18px;
        border-color: var(--custom-color);
        color: var(--custom-color);
      }
    }
  }
}
.page-en {
  .page-moblie {
    .my-referral-info {
      .reward-detail {
        .redeem-info {
          .redeem-detail-btn-container {
            width: 130px;
          }
        }
      }
    }
  }
}
.page-pc {
  .my-referral-info {
    padding: 0 40px;

    .card-container  {
      .card-title {
        font-size: 22px;
      }

      .card-content {
        display: flex;
        justify-content: center;
      }
    }
    .my-reward  {
      .reward-container {
        .reward-line {
          flex: 1;
          flex-direction: column;
          margin-top: 0;

          .reward-value {
            .value {
              font-size: 36px;
            }
          }

          .reward-btn {
            width: 125px;
            margin-top: 15px;
            padding: 8px 0;
            font-size: 14px;
          }
        }
      }
    }
    .reward-detail {
      .timeline-list {
        .timeline-item {
          .timeline-item-node {
            width: 50px;

            .node-icon {
              width: 12px;
              height: 12px;
            }
          }

          .timeline-item-timestamp {
            width: 60px;

            .timestamp-year {
              font-size: 18px;
            }
          }
        }
      }

      .referral-info {
        .applicant-name {
          font-size: 18px;
        }

        .reward-type  {
          .reward-value {
            width: 95px;
            margin-right: 145px;
            font-size: 18px;

            .reward-icon {
              i {
                font-size: 28px;
              }
            }
          }
        }
      }

      .redeem-info {
        .redeem-detail-btn-container {
          width: 295px;
          margin: auto 0;

          .redeem-detail-btn {
            width: 125px;
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
